<mat-card class="cardWithShadow">
    <mat-card-content>
        <mat-card-title class="header">
            Asignar Uso a Plantilla '{{data.name}}'
        </mat-card-title> <br>
        <div class="main-container">
            <form class="form_register_minutes" [formGroup]="form" (ngSubmit)="changueUsedAsing()">
              <section class="container-form">

                <mat-form-field>
                  <mat-label>Uso</mat-label>
                  <mat-select required formControlName="used">
                    <mat-option *ngFor="let use of documentUses" [value]="use.idUsed">
                      {{ use.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>                

              </section>
              <section class="button_class">
                <button
                  [disabled]="!form.valid"
                  mat-stroked-button
                  color="primary"
                  type="submit"
                  class="w-50"
                >
                  Guardar
                </button>
              </section>
            </form>
          </div>          
    </mat-card-content>
</mat-card>